import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '@/assets/css/onboarding.css';
import { setActiveOnboardingDriver } from '@/store/onboarding-store';
import i18n from '../i18n';
import { scrollTablesToRight, waitForAllElements } from './waitForDomElements';

const startBusinessGuide = (options = {}) => {
  const {
    onFinish = () => {},
  } = options;

  const steps = [
    {
      element: '.businesses-guide-table',
      popover: {
        title: i18n.t('onboarding.business.guide.table_title'),
        description: i18n.t('onboarding.business.guide.table_description'),
      },
    },
    {
      element: '.business-guide-details-btn-first',
      popover: {
        title: i18n.t('onboarding.business.guide.details_title'),
        description: i18n.t('onboarding.business.guide.details_description'),
      },
    },
    {
      element: '.business-guide-view-listing-btn-first',
      popover: {
        title: i18n.t('onboarding.business.guide.view_title'),
        description: i18n.t('onboarding.business.guide.view_description'),
      },
    },
    {
      element: '.business-guide-actions-activator-first',
      popover: {
        title: i18n.t('onboarding.business.guide.actions_title'),
        description: i18n.t('onboarding.business.guide.actions_description'),
      },
      onHighlightStarted: () => {
        window.dispatchEvent(new Event('onboarding:business-guide-open-actions-menu'));
      },
    },
    {
      element: '.business-guide-sync-action-first',
      popover: {
        title: i18n.t('onboarding.business.guide.sync_title'),
        description: i18n.t('onboarding.business.guide.sync_description'),
      },
      onHighlightStarted: () => {
        window.dispatchEvent(new Event('onboarding:business-guide-open-actions-menu'));
      },
    },
  ];

  const requiredSelectors = [
    '.businesses-guide-table',
    '.business-guide-details-btn-first',
    '.business-guide-view-listing-btn-first',
    '.business-guide-actions-activator-first',
  ];

  return waitForAllElements(requiredSelectors)
    .then((allFound) => {
      if (!allFound) {
        return false;
      }

      let isCompleted = false;

      const onboardingDriver = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['previous', 'next'],
        prevBtnText: i18n.t('onboarding.prev'),
        nextBtnText: i18n.t('onboarding.next'),
        doneBtnText: i18n.t('onboarding.done'),
        steps: steps.map((step, index) => {
          if (index === steps.length - 1) {
            return {
              ...step,
              popover: {
                ...step.popover,
                onNextClick: () => {
                  isCompleted = true;
                  onboardingDriver.destroy();
                },
              },
            };
          }
          return step;
        }),
        onDestroyed: () => {
          window.dispatchEvent(new Event('onboarding:business-guide-close-actions-menu'));
          if (isCompleted) {
            onFinish();
          } else if (options.onDeactivated) {
            options.onDeactivated();
          }
        },
      });

      setActiveOnboardingDriver(onboardingDriver);
      scrollTablesToRight(['.businesses-guide-table']);
      onboardingDriver.drive();

      return true;
    });
};

export { startBusinessGuide };
export default startBusinessGuide;
